import React from 'react';

import { flowRight } from 'lodash';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { OOI_EXPERIMENTS } from '@app/experiments';
import AppLoaded from '../../../common/components/app-loaded';
import ResponsiveListener from '../../../common/components/responsive-listener/responsive-listener';
import { withReduxStore } from '../../../common/components/runtime-context/with-redux-store';
import TagCloud from '../tag-cloud';
import styles from './app-root.scss';

type OwnProps = {};

const AppRoot: React.FC<OwnProps> = () => {
  return (
    <ResponsiveListener dataHook="tag-cloud-root" className={styles.baseStyles}>
      <>
        <TagCloud />
        <AppLoaded />
      </>
    </ResponsiveListener>
  );
};

/** @deprecated Remove when merging {@link OOI_EXPERIMENTS.USE_NEW_TAG_CLOUD_SETTINGS_URL} */
export default flowRight(withReduxStore)(AppRoot) as React.FC<OwnProps>;
